const TwilioDownBanner = ({ twilioStatusMsg }) => {
  return <p>{twilioStatusMsg}</p>;
};

export default TwilioDownBanner;
